<template>
    <div class="no-pd" v-resize="onResize">
        <v-app-bar 
            class="app__bar" 
            :color="navbarHome && showMenuMobile || !isLoggedIn || !showMenuMobile? currentCompany.primaryColor : 'white'" 
            :height="controlHeightOfNavbar? '86px' : '128px'"
            prominent
            :class="actualRoute == 'senha' ? 'app__bar--password' : ''"
        >
            <!-- COMEÇO - Navbar tela Início - Mobile #############-->
            <v-col class="flex-col-start max_width" :class="!showMenuMobile? 'app_bar--desktop__mg__top--company__avatar': ''" v-if="navbarHome || !isLoggedIn || !showMenuMobile" id="companyAvatarContainer__external">
                <div class="pointer text-truncate" :style="!isLoggedIn? 'padding-bottom: 20px;': ''" id="companyAvatarContainer__intern" @click="redirectToHome()">
                    <v-avatar size="46" class="avatar--border">
                        <img  :src="companyImage? companyImage : defaultUserImage">
                    </v-avatar>
                    <span class="app__bar--text" style="font-size: 16px" :style="{'color': currentCompany.fontColor}"> {{currentCompany.name}} </span>
                </div>

                <v-btn v-if="!isLoggedIn && showMenuMobile" class="app_bar--btn_height" text @click="redirectToSignup()">
                    <span class="text-none text-bold" :style="{'color': currentCompany.fontColor}"> Registro! </span>
                </v-btn>

                <v-btn v-if="!isLoggedIn && showMenuMobile" class="app_bar--btn_height" text @click="redirectToLogin()">
                    <span class="text-none" :style="{'color': currentCompany.fontColor}"> Entrar </span>
                </v-btn>

                <div v-if="isLoggedIn && showMenuMobile" class="app__bar--text flex-row-center" :style="{'color': currentCompany.fontColor}">Olá, {{currentUserName}} <v-img class="navbar__medal" max-height="20" max-width="20" src="@/assets/navbar-medal.svg" />  </div>

                <div v-if="isLoggedIn && showMenuMobile" class="app__bar--text text-bold" :style="{'color': currentCompany.fontColor}"> {{userPoints}} pontos </div>

                <div v-if="isLoggedIn && showMenuMobile" class="app__bar--text text--menor" :style="{'color': currentCompany.fontColor}"> JÁ ECONOMIZOU  <span class="text-bold"> {{moneySaved | currency(moneySaved)}} </span> </div>
            </v-col>
            <!-- FIM - Navbar tela Início - Mobile ############# -->

            <!-- INICIO - Navbar- Todas as telas -Mobile ############# -->
            <v-app-bar-nav-icon class="h-100" v-if="!navbarHome && showReturnScreenButton && showMenuMobile && isLoggedIn" @click="RETURN_TO_PREVIOUS_ROUTE()">
                <v-icon size="36" class="secundary__color">mdi-chevron-left</v-icon>
            </v-app-bar-nav-icon>

            <v-spacer v-if="showMenuMobile" />

            <div class="flex-col-center pointer h-100" v-if="!navbarHome && isLoggedIn && showMenuMobile" @click="redirectToHistoric()">
                <span class="app_bar_points text-bold secundary__color"> {{userPoints}} </span>
                <span class="app_bar_points--text text-bold"> pontos </span>
            </div>

            <v-spacer v-if="showMenuMobile" />

            <v-menu offset-y left v-if="showMenuMobile">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon :dark="darkTheme? true : false" v-bind="attrs" v-on="on" :class="!navbarHome && showMenuMobile && isLoggedIn? 'h-100': ''">
                        <div v-if="notificationNumber > 0" class="notification__indicator avatar__indicator" />
                        <v-avatar tile size="40px" class="pointer border-avatar block-auto" v-if="isLoggedIn">
                            <v-img contain class="avatar__image" :src="userImage? userImage : defaultUserImage" />
                        </v-avatar>
                        <v-icon v-if="navbarHome || !isLoggedIn" :style="{'color': currentCompany.fontColor}">mdi-dots-vertical</v-icon>
                        <v-icon v-if="!navbarHome && isLoggedIn" class="secundary__color">mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <div v-if="isLoggedIn">
                        <v-list-item class="pointer" v-for="menu in dropDownMenu" :key="menu.text" :to="menu.route">
                            <v-list-item-title class="flex-row-center">
                                {{ menu.text }}
                                <div class="notification__indicator" v-if="menu.text === 'Notificações' && notificationNumber > 0"> </div>
                            </v-list-item-title>
                        </v-list-item>
                    </div>

                    <v-list-item class="pointer" to="/inicio" v-if="showMenuMobile && !navbarHome && !isLoggedIn">
                        <v-list-item-title class="flex-row-center">
                            Inicio
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item class="pointer" to="/loja">
                        <v-list-item-title class="flex-row-center">
                            Nossas lojas
                        </v-list-item-title>
                    </v-list-item>

                    <v-divider v-if="isLoggedIn" />

                    <v-list-item v-if="isLoggedIn" class="pointer" @click="LOGOUT()">
                        <v-list-item-title>
                            Sair
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <!-- FIM - Navbar- Todas as telas -Mobile ############# -->


            <!-- INICIO - Navbar tela Início - Desktop ############# -->
            <v-spacer v-if="!showMenuMobile" />

            <div v-if="!showMenuMobile" class="flex-row-center">
                <v-toolbar-items class="app_bar--desktop__mg__top--toolbar">
                    <v-menu left offset-y v-model="chevronController" transition="slide-y-transition" v-if="isLoggedIn && actualRoute != 'senha'">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon class="app_bar__dropDownBenefitProgram text-none" :dark="darkTheme? true : false" v-bind="attrs" v-on="on" :style="{'color': currentCompany.fontColor}">
                                <div>
                                    Clube de benefícios
                                    <v-icon class="app_bar__dropDownBenefitProgram--chevron" v-show="!chevronController">mdi-chevron-down</v-icon>
                                    <v-icon class="app_bar__dropDownBenefitProgram--chevron" v-show="chevronController">mdi-chevron-up</v-icon>
                                </div>
                            </v-btn>
                        </template> 
                        <v-list>
                            <v-list-item class="pointer" v-for="item in dropDownBenefitProgram" :key="item.text" :to="item.route">
                                <v-list-item-title class="flex-row-center">
                                    {{ item.text }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-btn v-if="actualRoute != 'senha'" class="text-none" :style="{'color': currentCompany.fontColor}" text to="/inicio"> Inicio </v-btn>
                    <v-btn class="text-none" :style="{'color': currentCompany.fontColor}" text to="/loja"> Loja </v-btn>
                    <v-btn v-if="actualRoute != 'senha'" class="text-none" :style="{'color': currentCompany.fontColor}" text to="/perfil"> Perfil </v-btn>
                    <v-btn v-if="isLoggedIn" class="text-none" :style="{'color': currentCompany.fontColor}" text to="/historico"> Historico </v-btn>
                    <v-btn v-if="isLoggedIn" class="text-none" :style="{'color': currentCompany.fontColor}" text to="/notificacoes">
                        Notificações
                        <div class="notification__indicator" v-if="notificationNumber > 0"> </div>
                    </v-btn>
                </v-toolbar-items>
            </div>

            <v-spacer v-if="!showMenuMobile" />

            <div v-if="!isLoggedIn && !showMenuMobile" class="flex-col-start app_bar--dontLoggedIn__btns-container app_bar--desktop__mg__top--register__login">
                <v-btn class="app_bar--btn_height" text @click="redirectToSignup()">
                    <span class="text-none text-bold" :style="{'color': currentCompany.fontColor}"> Registro! </span>
                </v-btn>

                <v-btn class="app_bar--btn_height" text @click="redirectToLogin()">
                    <span class="text-none" :style="{'color': currentCompany.fontColor}"> Entrar </span>
                </v-btn>
            </div>

            <div class="flex-row-center-space-around app_bar--desktop__mg__top--user__avatar" v-if="isLoggedIn && !showMenuMobile" id="userAvatarContainer__external">
                <div class="flex-col-end" id="userAvatarContainer__intern">
                    <div class="app__bar--text flex-row-center" :style="{'color': currentCompany.fontColor}" style="margin-left: -18px"><v-img class="navbar__medal" max-height="20" max-width="20" src="@/assets/navbar-medal.svg" /> Olá, {{currentUserName}} </div>

                    <div class="app__bar--text text-bold" :style="{'color': currentCompany.fontColor}"> {{userPoints}} pontos </div>

                    <div class="app__bar--text text--menor" :style="{'color': currentCompany.fontColor}"> JÁ ECONOMIZOU  <span class="text-bold"> {{moneySaved | currency(moneySaved)}} </span> </div>
                </div>

                <v-menu offset-y left v-if="isLoggedIn">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon :dark="darkTheme? true : false" v-bind="attrs" v-on="on" class="app_bar--desktop__avatar">
                            <v-avatar tile size="48px" class="pointer border-avatar block-auto" v-if="isLoggedIn">
                                <v-img contain class="avatar__image" :src="userImage? userImage : defaultUserImage" />
                            </v-avatar>
                        </v-btn>
                    </template> 
            
                    <v-list>
                        <v-list-item v-if="isLoggedIn" class="pointer" @click="LOGOUT()">
                            <v-list-item-title>
                                Sair
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
            <!-- FIM - Navbar tela Início - Desktop ############# -->
        </v-app-bar>

        <!-- BANNER-mobile ############# -->
        <v-row class="no-pd w-100 flex-row-center app__bar--row" v-if="navbarHome && showBannerMobile && bannerImages.length > 0">
            <v-col class="app_bar__carousel--container" xs="12" cols="12" sm="12" md="12">
                <v-card class="no-pd app_bar__carousel--card" elevation="1">
                    <v-carousel 
                      class="app_bar__carousel--mobile" 
                      cycle 
                      :show-arrows="false" 
                      hide-delimiter-background 
                      delimiter-icon="mdi-minus" 
                      height="14vh"
                    >
                      <v-carousel-item                        
                        v-for="(imageObject, index) in bannerImages"
                        :key="index"
                        :src="imageObject.image"
                        reverse-transition="fade-transition"
                        transition="fade-transition"
                      />
                    </v-carousel>
                </v-card>
            </v-col>
        </v-row>

        <!-- BANNER-Desktop ############# -->
        <v-carousel 
            v-if="navbarHome && !showBannerMobile && bannerImages.length > 0" 
            cycle
            hide-delimiter-background 
            delimiter-icon="mdi-minus" 
            height="28vh"
            :show-arrows="bannerImages.length > 1"
        >
            <v-carousel-item v-for="(imageObject, index) in bannerImages" :key="index" :src="imageObject.image" reverse-transition="fade-transition" transition="fade-transition" />
        </v-carousel>

        <div v-if="actualRoute != 'senha' && (!navbarHome || !bannerImages.length > 0 )" class="margin-bt-divider-30" />
    </div>
</template>

<script>
//Store
import { mapActions, mapGetters } from "vuex";

//Services
import { 
    getUnreadNotificationsQuantityByCurrentContactIdAndCompanyId,
    getRemainingPointsByCompanyIdAndCurrentContactId,
    getSavedMoneyByCompanyIdAndCurrentContactId,
    getHomeBannersByCompanyId
} from "@/app/shared-components/navbar/service/navbar.service";

export default {
    name: 'navbar',
    computed: {
        defaultUserImage() {
            return require('@/assets/default-user-intern.png')
        },
        showBannerMobile() {
            if(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md) return true
            else return false
        },
        showMenuMobile() {
            if(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) return true
            else return false
        },
        controlHeightOfNavbar() {
            if(!this.navbarHome && this.showMenuMobile && this.isLoggedIn) return true
            else return false
        },
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany',
                companyImage: 'get_currentCompanyImage',
                currentUserName: 'get_currentUserFirstName',
                userPoints: 'get_currentCompanyPoints',
                isLoggedIn: 'isLoggedIn'
            }
        ),
        ...mapGetters(
            'userStore', {
                userImage:  'get_userImage'
            }
        ),
        ...mapGetters('routeStore', {
                actualRoute: 'get_actualRoute',
                showReturnScreenButton: 'get_showReturnScreenButton'
            }
        )
    },
    watch: {
        actualRoute: {
            immediate: true,
            handler() {
                if(this.actualRoute.startsWith('inicio') ) this.navbarHome = true 
                else this.navbarHome = false
            }
        },
        currentCompany: {
            immediate: true,
            deep: true,
            handler() {
                if(this.currentCompany) this.getBasicInfo()
            }
        },
        isLoggedIn() {
            this.getBasicInfo()
        }
    },
    data: () => ({
        dropDownMenu: [
            { text: 'Inicio', route: '/inicio'},
            { text: 'Notificações', route: '/notificacoes'},
            { text: 'Perfil', route: '/perfil'},
            { text: 'Histórico', route: '/historico'},
        ],
        dropDownBenefitProgram: [
            { text: 'Ofertas', route: '/ofertas'},
            { text: 'Prog. de pontos', route: '/pontos'},
            // { text: 'Indicar amigos', route: '/inicio'},
            { text: 'Jornal de Ofertas', route: '/jornal'},
            // { text: 'Prêmios', route: '/premios'},
        ],
        moneySaved: 0,
        notificationNumber: null,
        bannerImages: [],
        navbarHome: false,
        darkTheme: false,
        companyAvatarContainerWidth: null,
        chevronController: false,
    }),
    created() {
        this.setAllScreenColors()
    },
    mounted() {
        this.observeCompanyAvatarContainer()
        this.observeUserAvatarContainer()
    },
    methods:{
        ...mapActions('authenticateStore',['LOGOUT']),
        ...mapActions('routeStore', ['RETURN_TO_PREVIOUS_ROUTE']),
        getBasicInfo() {
            if(this.currentCompany.id) {
                getUnreadNotificationsQuantityByCurrentContactIdAndCompanyId(this.currentCompany.id) //Só chama se estiver autenticado
                    .then( success => {
                            this.notificationNumber = success.data.quantity
                        }
                    )
                    .catch( error => {
                            if (error != null) {
                                this.$toasted.show(error.message, { type: 'error' } )
                            }
                        }
                    )
                getSavedMoneyByCompanyIdAndCurrentContactId(this.currentCompany.id) //Só chama se estiver autenticado
                    .then( success => {
                            this.moneySaved = success.data.savedMoney
                        }
                    )
                    .catch( error => {
                            if (error != null) {
                                this.$toasted.show(error.message, { type: 'error' } )
                            }
                        }
                    )
                getHomeBannersByCompanyId(this.currentCompany.id)
                    .then( success => {
                            this.bannerImages = success.data
                        }
                    )
                    .catch( error => {
                            if (error != null) {
                                this.$toasted.show(error.message, { type: 'error' } )
                            }
                        }
                    )
            }
        },
        setAllScreenColors() {
            this.darkTheme = !(this.verifyColorShine(this.currentCompany.primaryColor))
        },
        verifyColorShine( hexadecimalOfColor ) { //Função que verifica se a Cor em Hexadecimal é escura ou clara. Retorna 1 para cores claras e 0 para cores escuras
            let r,g,b, luminosidade             
            let internHex = hexadecimalOfColor.replace('#', '')

            r = parseInt(internHex.substr(0,2))
            g = parseInt(internHex.substr(2,2))
            b = parseInt(internHex.substr(4,2))

            luminosidade = ( r * 299 + g * 587 + b * 114) / 1000
            
            return ( luminosidade > 127.5 ) // já que 1 e 0 podem ser representados por true e false, eu alterei o método pra retornar um boolean
        },
        redirectToHome() {
            this.$router.push('/inicio')
        },
        redirectToPointsProgram() {
            this.$router.push('/programaPontos')
        },
        redirectToSignup() {
            this.$router.push('/acessos')
        },
        redirectToLogin() {
            this.$router.push('/login')
        },
        redirectToHistoric() {
            this.$router.push('/historico')
        },
        setCompanyAvatarWidth() {
            let companyAvatarContainerWidth = document.getElementById('companyAvatarContainer__intern').offsetWidth
            document.getElementById('companyAvatarContainer__external').setAttribute('style', `max-width: ${companyAvatarContainerWidth + 3}px !important`)
        },
        setUserAvatarWidth() {
            let avatarContainerWidth = document.getElementById('userAvatarContainer__external').offsetWidth
            document.getElementById('userAvatarContainer__external').setAttribute('style', `min-width: ${avatarContainerWidth + 3}px !important`)
        },
        onResize() {
            this.observeUserAvatarContainer()
            this.observeCompanyAvatarContainer()
        },
        observeCompanyAvatarContainer() {
            if(!this.isLoggedIn && !this.showMenuMobile) this.setCompanyAvatarWidth()
        },
        observeUserAvatarContainer() {
            if(this.isLoggedIn && !this.showMenuMobile) this.setUserAvatarWidth()
        }
    }
}
</script>

<style scoped>
.max_width {
    max-width: 180px !important;
}
.border-avatar {
    border-radius: 30px;
}
.app__bar--text {
    font-size: 14px;
    font-family: 'nunito', sans-serif;
}
.text--menor {
    font-size: 12px !important;
}
.app__bar {
    padding: 0px 16px 4px 16px !important;
}   
.notification__indicator {
    border-radius: 100%;
    background-color: var(--cor--roza);
    height: 8px;
    width: 8px;
    margin-left: 4px;
}
.avatar__indicator {
    position: absolute;
    z-index: 1;
    border: 1px solid var(--cor--branco);
    top: -1px;
    left: -1px;
}
.avatar__image {
    border: 1px solid var(--cor--branco);
}
.app_bar--desktop__avatar {
    margin-left: 12px;
}
.navbar__medal{
    margin-left: 4px;
}
.app_bar__carousel--container {
    padding: 0px 24px 16px 24px;
}
.app_bar__carousel--mobile {
    border-radius: 10px !important;
}
.app__bar--row {
    background: linear-gradient(to bottom, black, white ) !important;
    
}
.app_bar__carousel--card {
    border-radius: 10px !important;
}
.secundary__color {
    color: var(--cor--secundaria) !important;
}
.app_bar_points {
    font-size: 18px;
    height: 20px;
}
.app_bar_points--text {
    font-size: 16px;
}
.app_bar--btn_height {
    height: 20px !important;
}
.app_bar--dontLoggedIn__btns-container {
    min-width: 84px !important;
    max-width: 86px !important;
}
.app_bar--desktop__mg__top--register__login {
    margin-top: 47px;
}
.app_bar--desktop__mg__top--toolbar {
    margin-top: 55px;
}
.app_bar--desktop__mg__top--user__avatar {
    margin-top: 34px;
}
.app_bar--desktop__mg__top--company__avatar {
    margin-top: 28px;
}
.app_bar__dropDownBenefitProgram {
    min-width: 178px;
}
.app_bar__dropDownBenefitProgram--chevron {
    margin-top: -2px;
    margin-left: -9px;
}
.app__bar--password {
    padding-left: 5% !important;
    padding-right: 10% !important;
}
</style>